import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a31092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ticket" }
const _hoisted_2 = { class: "ticket-container" }

import BreadcrumbBlock from '../pubilcComponents/breadcrumbBlock.vue';
import Summary from './components/summary.vue';
import Efficiency from './components/efficiency.vue';
import Genre from './components/genre.vue';
// import Staff from './components/staff.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BreadcrumbBlock, { customDateShow: true }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Summary),
      _createVNode(Efficiency),
      _createVNode(Genre)
    ])
  ]))
}
}

})